import "./style.scss";
import domReady from "@wordpress/dom-ready";

function timeline() {
  const els = document.querySelectorAll(".wp-block-intempus-timeline");

  function scroller(el) {
    const { height, y } = el.getBoundingClientRect();

    const offsetY = y + height - 300;
    let percent = 100 - (100 * offsetY) / height;

    if (percent < 0) {
      percent = 0;
    }

    if (percent > 100) {
      percent = 100;
    }

    el.style.setProperty("--line-height", `${percent}%`);
  }

  els.forEach((el) => {
    scroller(el);
    window.addEventListener("scroll", scroller.bind(null, el));
  });

  const icons = document.querySelectorAll(".feature-icon");

  function iconActivate(icon) {
    const iconY = icon.getBoundingClientRect().y;
    if (iconY > 295) {
      icon.classList.remove("active");
    } else {
      icon.classList.add("active");
    }
  }

  icons.forEach((icon) => {
    iconActivate(icon);
    window.addEventListener("scroll", iconActivate.bind(null, icon));
  });
}

domReady(timeline);
